/* Fit Girl — theme behaviour.
   Cart + add-to-cart are Dawn's own (product-form.js + cart-drawer.js). */
(function () {
  'use strict';

  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- header border once scrolled ---------- */
  var header = $('.fg-header');
  var onScroll = function () { if (header) header.classList.toggle('is-stuck', window.scrollY > 4); };
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- mobile menu ---------- */
  var menu = $('.fg-menu');
  var burger = $('[data-fg-open-menu]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (open) menu.removeAttribute('inert'); else menu.setAttribute('inert', '');
    document.body.classList.toggle('no-scroll', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    var target = open ? $('[data-fg-close-menu]', menu) : burger;
    if (target) target.focus();
  }
  if (burger) burger.addEventListener('click', function () { setMenu(true); });
  $$('[data-fg-close-menu]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
  $$('.fg-menu a').forEach(function (a) { a.addEventListener('click', function () { setMenu(false); }); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) setMenu(false);
  });

  /* ---------- quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-fg-step]');
    if (!b) return;
    var input = b.parentNode.querySelector('input');
    var max = parseInt(input.max, 10) || 99;
    var v = (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-fg-step'), 10);
    input.value = Math.max(1, Math.min(max, v));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- gallery thumbs ---------- */
  $$('[data-fg-gallery]').forEach(function (g) {
    var main = $('.fg-buy__main img', g);
    if (!main) return;
    $$('.fg-thumb', g).forEach(function (t) {
      t.addEventListener('click', function () {
        $$('.fg-thumb', g).forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-pressed', 'false'); });
        t.classList.add('is-active');
        t.setAttribute('aria-pressed', 'true');
        // srcset must be rewritten too, or the browser keeps showing the old image
        main.srcset = t.getAttribute('data-srcset') || '';
        main.src = t.getAttribute('data-src');
        main.alt = t.getAttribute('data-alt') || '';
      });
    });
  });

  /* ---------- variant swatches (only rendered for multi-variant products) ---------- */
  $$('[data-fg-variants]').forEach(function (wrap) {
    var scope = wrap.closest('[data-fg-buy]');
    var idInput = $('input[name="id"]', scope);
    var price = $('.fg-price__now', scope);
    var was = $('.fg-price__was', scope);
    var label = $('[data-fg-variant-label]', scope);
    var submit = $('.fg-buy__form [type="submit"]', scope);
    $$('.fg-swatch', wrap).forEach(function (sw) {
      sw.addEventListener('click', function () {
        $$('.fg-swatch', wrap).forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        sw.setAttribute('aria-pressed', 'true');
        idInput.value = sw.getAttribute('data-id');
        if (price) price.textContent = sw.getAttribute('data-price');
        if (was) { was.textContent = sw.getAttribute('data-compare') || ''; was.hidden = !sw.getAttribute('data-compare'); }
        if (label) label.textContent = sw.getAttribute('data-title');
        var available = sw.getAttribute('data-available') === 'true';
        if (submit) {
          submit.disabled = !available;
          $('span', submit).textContent = available ? submit.getAttribute('data-label-add') : submit.getAttribute('data-label-sold');
        }
      });
    });
  });

  /* ---------- buy it now (plain POST to /cart/add?return_to=/checkout) ----------
     Only a busy state; the form works without JS. */
  function buttonsFor(form) {
    return $$('button[type="submit"]', form).concat(form.id ? $$('button[form="' + form.id + '"]') : []);
  }
  $$('form[data-fg-buynow]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (form.getAttribute('data-busy') === 'true') { e.preventDefault(); return; }
      form.setAttribute('data-busy', 'true');
      buttonsFor(form).forEach(function (b) {
        b.setAttribute('aria-busy', 'true');
        b.setAttribute('data-label', b.textContent);
        var span = $('span', b) || b;
        span.textContent = 'processing…';
      });
    });
  });
  // back button restores the page from bfcache without re-running scripts
  window.addEventListener('pageshow', function () {
    $$('form[data-fg-buynow]').forEach(function (form) {
      form.removeAttribute('data-busy');
      buttonsFor(form).forEach(function (b) {
        if (!b.hasAttribute('data-label')) return;
        b.removeAttribute('aria-busy');
        var span = $('span', b) || b;
        span.textContent = b.getAttribute('data-label').trim();
        b.removeAttribute('data-label');
      });
    });
  });

  /* ---------- sticky buy bar (product page, mobile) ---------- */
  var bar = $('.fg-sticky-buy');
  var anchor = $('.fg-pdp .fg-buy__row');
  if (bar && anchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var b = $('button', bar);
      if (b) b.tabIndex = show ? 0 : -1;
    }).observe(anchor);
  }

  /* ---------- Dawn drawer: first add of a session ----------
     <cart-drawer> is rendered with class "is-empty" when the cart is empty, but
     renderContents() only clears it on .drawer__inner — so the first add opens a
     drawer whose line items are hidden. Clear it ourselves on every cart update. */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      // only after an add — a quantity change to 0 must keep Dawn's empty state
      if (!event || event.source !== 'product-form') return;
      var drawer = document.querySelector('cart-drawer');
      if (drawer) drawer.classList.remove('is-empty');
    });
  }
})();
